<template>
  <svg :width="36 * scale" :height="30 * scale" viewBox="0 0 36 30">
    <polygon points="0,15 10,30 33,0 10,22" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    scale: { type: Number, default: 1 },
  },
});
</script>
